const ARRAY_ERROR = 'FINAL_FORM/array-error';

/**
 * Разворачивает объект ошибок final-form в плоский список путей до полей
 * в формате имён полей: `requirementsNpaErknm[0].npa`.
 *
 * В отличие от `Object.keys(visited)` не зависит от того, смонтировано поле или нет:
 * аккордеоны (`KnmCollapse`) не рендерят содержимое до первого раскрытия, поэтому
 * поля внутри свёрнутых блоков во final-form не зарегистрированы.
 */
export const getFormErrorsFlatNames = (errors: unknown): string[] => {
  const result: string[] = [];

  const walk = (node: unknown, path: string) => {
    if (!node) return;

    if (typeof node === 'string') {
      if (path) result.push(path);

      return;
    }

    if (Array.isArray(node)) {
      // ошибка самого массива лежит на нечисловом ключе, см. getArrayError
      if (((node as unknown) as Record<string, unknown>)[ARRAY_ERROR] && path) result.push(path);

      node.forEach((item, index) => walk(item, `${path}[${index}]`));

      return;
    }

    if (typeof node === 'object') {
      Object.keys(node as object).forEach(key => {
        if (key === ARRAY_ERROR) {
          if (path) result.push(path);

          return;
        }

        walk((node as Record<string, unknown>)[key], path ? `${path}.${key}` : key);
      });
    }
  };

  walk(errors, '');

  return Array.from(new Set(result));
};
